export const getFileExt = (link: string) => {
  if (!link) return "";
  // If the url has queries we have to ignore them
  link = link.split("?")[0];
  const split = link.split(".");
  const ext = split[split.length - 1];
  return ext;
};
